import jwtDecode from 'jwt-decode';
import fp from 'lodash/fp';
import queryString from 'query-string';
import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Redirect } from 'react-router-dom';
import { push } from 'react-router-redux';
import { branch, compose, lifecycle, renderComponent, withHandlers, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../constants';
import { sessionActions } from '../../../state/modules/session';
import { userActions } from '../../../state/modules/user';
import Loading from '../loading';

const InvalidInvitation = ({ performLogout, location: { search }, businessName }) => (
  <div id='accept-invitation'>
    <Grid>
      <Row>
        <Col xs={12}>
          <h1 className="text-center">Invitation expired</h1>
          <p>Your invitation to {businessName} has expired. If you think this has happened by mistake, please let us know <a href="mailto:support@thinkcaddie.com?cc=helpdesk@complii.com.au">here</a>.</p>
          <LinkContainer className='full large' exact to={{ pathname: routes.logout, search }}>
            <Button onClick={performLogout} >Return to login</Button>
          </LinkContainer>
        </Col>
      </Row>
    </Grid>
  </div>
);

const ExceedsMaxInvitation = ({ businessAdminEmail, performLogout, location: { search } }) => (
  <div id='accept-invitation'>
    <Grid>
      <Row>
        <Col xs={12}>
          <h1 className="text-center">Whoops, looks like this business is full</h1>
          <p>It looks like your business has exceeded the number of Caddie licenses available.</p>
          <p>We've reached out to your business administrator to increase the number of licenses so you can sign up to Caddie.</p>
          <p>You can also contact your administrator directly by emailing them at <a href={`mailto:${businessAdminEmail}`}>{businessAdminEmail}</a> or you can get in touch with Caddie at <a href="mailto:support@thinkcaddie.com?cc=helpdesk@complii.com.au">support@thinkcaddie.com</a></p>
          <LinkContainer className='full large' exact to={{ pathname: routes.logout, search }}>
            <Button onClick={performLogout} >Return to login</Button>
          </LinkContainer>
        </Col>
      </Row>
    </Grid>
  </div>
)

const AcceptInvitation = ({ businessName, performLogoutWithInvitation, location: { search } }) => (
  <div id='accept-invitation'>
    <Grid>
      <Row>
        <Col xs={12}>
          <h1 className="text-center">You have been invited {businessName ? `by ${businessName}` : ''} to join Caddie</h1>
          <LinkContainer className='full large' exact to={{ pathname: routes.onboarding.invitationSignUp, search }}>
            <Button>Accept Invitation</Button>
          </LinkContainer>
          <LinkContainer className='full large' exact to={{ pathname: routes.logout, search }}>
            <Button onClick={performLogoutWithInvitation} bsStyle="plain" >I've already got a Caddie account</Button>
          </LinkContainer>
        </Col>
      </Row>
    </Grid>
  </div>
);

const mapStateToProps = (state) => ({
  invitationChecked: state.business.invitationChecked,
  validInvitation: state.business.validInvitation,
  verifyResult: state.business.verifyInvitationResult
});

const mapDispatchToProps = (dispatch) => ({
  logout: bindActionCreators(sessionActions.session.logout, dispatch),
  checkInvitation: bindActionCreators(userActions.user.checkInvitation, dispatch),
  goTo: bindActionCreators(push, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(({ verifyResult }) => ({
    businessAdminEmail: typeof verifyResult === 'string' ? verifyResult : undefined,
    userExist: fp.get('userExist')(verifyResult)
  })),
  withStateHandlers(() => ({
    businessName: null
  })),
  lifecycle({
    componentDidMount() {
      const invitationToken = queryString.parse(this.props.location.search).invitationToken;
      // If we have invalid token provided, boot User to login page.
      try {
        const { businessId, businessName } = jwtDecode(invitationToken);
        this.setState({ businessName });
        this.props.checkInvitation(invitationToken, parseInt(businessId, 10));
      }
      catch (e) {
        this.props.goTo(routes.login);
      }
    }
  }),
  withHandlers({
    performLogoutWithInvitation: ({
      logout,
      location: { search }
    }) => (event) => {
      event.preventDefault();
      event.stopPropagation();
      const invitationToken = queryString.parse(search).invitationToken;
      logout(invitationToken)
    },
    performLogout: ({
      logout
    }) => fp.over([
      (event) => event.preventDefault(),
      (event) => event.stopPropagation(),
      (event) => logout()
    ])
  }),
  branch(
    ({ invitationChecked }) => !invitationChecked,
    renderComponent(Loading)
  ),
  branch(
    ({ validInvitation }) => !validInvitation,
    renderComponent(InvalidInvitation)
  ),
  branch(
    ({ businessAdminEmail }) => businessAdminEmail,
    renderComponent(ExceedsMaxInvitation)
  ),
  branch(
    ({ userExist }) => userExist,
    renderComponent(
      ({ location: { search } }) => {
        return <Redirect to={{ pathname: routes.app.confirmAcceptInvitation, search }} />
      }
    ),
    renderComponent(
      ({ location: { search } }) => {
        return <Redirect to={{ pathname: routes.onboarding.invitationSignUp, search }} />
      }
    )
  )
)(AcceptInvitation);


// WEBPACK FOOTER //
// ./src/containers/pages/onboarding/accept-invitation.js